import { gql } from '@ts-gql/tag'

export const GetGiftCardsQuery = gql`
  query GiftCards($country: String!) {
    cfContentPageCollection(
      where: {
        AND: [{ path: "gift-cards" }, { country_contains_all: [$country] }]
      }
      limit: 1
    ) {
      items {
        sys {
          id
        }
        navigationMenu
        title
      }
    }
  }
` as import('../../../../__generated__/ts-gql/GiftCards').type
